import { useState } from 'react';
import Image from '../image/Image';
import logoutImage from './assets/log-out.png';
import platformImage from './assets/platform.png';
import { useOutsideClick } from '../../hooks/useOutsideClick';
import './UserDropdown.scss';

type Props = {
    username: string;
    onLogout: () => void;
    onGoToPlatform: () => void;
};

export const UserDropdown = ({ username, onLogout, onGoToPlatform }: Props) => {
    const [ open, setOpen ] = useState(false);
    const ref = useOutsideClick<HTMLDivElement>(() => setOpen(false));

    return (
        <div className="userDropdown" ref={ref}>
            <button
                onClick={() => setOpen((prev) => !prev)}
                className="userDropdown_username"
            >
                {username} ⏷
            </button>

            {open && (
                <div className="userDropdown_actionsContainer">
                    <div
                        className="userDropdown_actionsContainer_actionItem"
                        onClick={() => {
                            onGoToPlatform();
                            setOpen(false);
                        }}
                    >
                        <Image src={platformImage} alt="platform"/>
                        <span>Platform</span>
                    </div>
                    <div
                        className="userDropdown_actionsContainer_actionItem"
                        onClick={() => {
                            onLogout();
                            setOpen(false);
                        }}
                    >
                        <Image src={logoutImage} alt="logout"/>
                        <span className="logout">Logout</span>
                    </div>
                </div>
            )}
        </div>
    );
};